var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning",
    clipPath: "url(#clip0_2389_42717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50043 0C2.01478 0 0 2.0148 0 4.50043L0 13.4996C0 15.9852 2.0148 18 4.50043 18H13.4996C15.9852 18 18 15.9852 18 13.4996V4.50043C18 2.01478 15.9852 0 13.4996 0L4.50043 0ZM9.00929 4.50043C9.50624 4.50043 9.9087 4.90289 9.9087 5.39985V9.00002C9.9087 9.49698 9.50624 9.90028 9.00929 9.90028C8.51233 9.90028 8.10903 9.49698 8.10903 9.00002V5.39985C8.10903 4.90289 8.51233 4.50043 9.00929 4.50043ZM8.09976 12.6002C8.09976 12.1032 8.50306 11.6999 9.00002 11.6999H9.0093C9.50626 11.6999 9.90872 12.1032 9.90872 12.6002C9.90872 13.0971 9.50626 13.4996 9.0093 13.4996H9.00002C8.50306 13.4996 8.09976 13.0971 8.09976 12.6002Z",
    fill: "#DF2935"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2389_42717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.cfa7cc246a1120863fc589b0d2e08259.svg";
export { ForwardRef as ReactComponent };